export const ERROR_TYPES = {
	EMAIL_ALREADY_EXISTS: 'EmailAlreadyExists',
	NO_AVAILABLE_TIME: 'NoAvailableTime',
	AUTHORIZE_NET_ADDING_CARD: 'AuthorizeNetAddingCard',
	CONNECTION_ERROR: 'ConnectionError',
	AREA_UNAVAILABLE: 'AreaUnavailable',
};
